import cookie from 'js-cookie'

import { ILogoutData } from 'meta/auth'
import { ApiEndpoint } from 'controller/endpoint'
import { CookieName } from 'utils/cookie'
import { HttpRequest } from 'utils/http'

export const logoutUser = async (): Promise<ILogoutData> => {
  const { data } = await HttpRequest.post<ILogoutData>(ApiEndpoint.users.logout(), {})

  cookie.remove('token')
  cookie.remove(CookieName.FAST_CHECKOUT_OBJECT)
  cookie.remove(CookieName.FAST_CHECKOUT_OTP_TOKEN)
  cookie.remove(CookieName.LAST_TRANSACTION)
  window.localStorage.setItem('logout', String(Date.now()))

  return data
}
